export default __webpack_public_path__ + "static/media/highScoreTableProj.a5e82cf7.jpg";